import { Box } from "@chakra-ui/react";

export const InnerContainer = (props: any) => {
  return (
    <Box>
      <Box>{props.children}</Box>
    </Box>
  );
};
